import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LOYALTY_STATUS } from '../../actions/Loyalty';

class LoyaltySelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      listItems: [
        { id: LOYALTY_STATUS.BECOME_MEMBER, label: 'Client wants to be a member of {loyalty}.' },
        { id: LOYALTY_STATUS.IS_MEMBER, label: 'Client is already a member.' },
        { id: LOYALTY_STATUS.DONT_WANT_MEMBER, label: 'Client does not want to be a member.' }],
    };
  }

  render() {
    return (
      <div>
        <div className="flex">
          <ul className="flex loyaltyList">
            {this.state.listItems.map((item) => (
              <li key={item.id}
                  className={`option md:flex-grow-default ${this.props.selectedStatus === item.id ? 'selected' : ''}`}
                  onClick={() => this.props.onSelect(item.id)}>
                {this.context.t(item.label, { loyalty: this.props.loyaltyName })}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

LoyaltySelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

LoyaltySelector.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  selectedStatus: state.loyalty.selectedStatus,
});

export default connect(mapStateToProps)(LoyaltySelector);
